import { Spinner } from '@tink/core/src/components/atoms/Spinner/Spinner';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { useIntl } from 'react-intl';
import { CircularLogo } from '../../Templates/TemplateColor.styles';
import { styled } from '../../../core/theme/styled';
import { messages } from '../../../core/screens/LoadingOverlay/messages';

export type LogoSpinnerProps = {
  ariaLabel?: string;
  iconUrl: string;
};

const spinnerDiameterPx = 80;
const iconDiameterPx = 60;

export const IconOverlay = styled.div`
  height: ${spinnerDiameterPx}px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoSpinner = ({ iconUrl, ariaLabel }: LogoSpinnerProps) => {
  const { formatMessage } = useIntl();
  const spinnerAriaLabel = ariaLabel ?? formatMessage(messages.label);

  return (
    <Box mx="normedium" my="normedium" data-testid="logo-spinner" relative>
      <Spinner aria-label={spinnerAriaLabel} size={spinnerDiameterPx} thickness={1} />
      <IconOverlay>
        <CircularLogo src={iconUrl} diameter={iconDiameterPx} />
      </IconOverlay>
    </Box>
  );
};
